<template>
  <nav class="flex-1 space-y-1 px-2">
    <slot />
  </nav>
</template>
